<template>
  <carousel
    v-if="articles && articles.length"
    :autoplay="true"
    :loop="true"
    :perPage="getPerPage()"
    :autoplayTimeout=4000
    class="mb-5"
  >
    <slide
      v-for="article in articles.slice(0,8)"
      :key="article.id"
    >
      <div class="slide-inner">
        <article-card :article="article" />
      </div>
    </slide>
  </carousel>
</template>

<script>
  import restApi from "@/rest-api";
  import { Carousel, Slide } from 'vue-carousel';
  import ArticleCard from '@/components/ArticleCard.vue';

  export default {
    components: {
      Carousel,
      Slide,
      ArticleCard
    },
    data() {
        return {
            articles:[]
        }
    },
    created() {
      this.fetchArticles();
    },
    methods: {
      getPerPage() {
        if (this.$vuetify.breakpoint.xs) {
          return 1
        } else if(this.$vuetify.breakpoint.lgAndUp) {
          return this.articles.length >=4 ? 4 : 3
        } else {
          return 2
        }
      },
      fetchArticles() {
        // only the first 8 are shown
        var search = `/article/filtered?page=1&per_page=8`;
        restApi
        .get(search)
        .then(response => {
              this.articles = response.data
        })
        .catch((error) => {
            console.log(error);
        });
      },
    }
  }
</script>

<style scoped>
  .VueCarousel {
    max-width: 100%;
  }

  .slide-inner {
    height: 100%;
    padding: 8px 10px 16px;
  }

  .VueCarousel-slide {
    display: flex;
  }
</style>
